import KPIIcon from '~/shared/assets/icons/kpi.svg';
import Typography from '~/shared/components/Typography';
import KPICard from '~/shared/components/KPICard';
import Tag from '~/shared/components/Tag';
import { KPIHeader, KPISkeletonLoader } from '~/shared/components/kpi';

export default function AverageUtilizationCard({
  size,
  volumeCount,
  loading,
}: {
  size: string;
  volumeCount?: string;
  loading: boolean;
}) {
  return (
    <KPICard className="flex flex-col justify-between gap-[18px] h-full min-w-[320px]">
      <KPIHeader
        icon={KPIIcon}
        title="Average Utilization"
        subtitle="Of monitored volumes, over the last 24 hours"
      />
      <div className="flex items-end justify-between gap-3">
        {loading ? (
          <>
            <KPISkeletonLoader width={50} variant="value" />
            <KPISkeletonLoader width={58} variant="valueSm" className="shrink-0" />
          </>
        ) : (
          <>
            <Typography
              fontWeight={600}
              variant="H3-resp"
              color="text-primary-900"
              className="font-family-outfit"
            >
              {size}
            </Typography>
            {volumeCount && (
              <Tag variant="kpi" size="kpi" text={volumeCount} className="shrink-0" showFullText />
            )}
          </>
        )}
      </div>
    </KPICard>
  );
}
